module.exports = __webpack_public_path__ + "img/epay-code.7632b2a8.jpg";